import React from 'react';
import { LocalServicePage } from '../../components/LocalServicePage';

export const LocksmithCanaryWharf = () => {
  return (
    <LocalServicePage
      areaName="Canary Wharf"
      areaType="Place"
      slug="locksmith-canary-wharf"
      heroTitle="Commercial & Managed Building Services in Canary Wharf"
      heroSubtitle="Royal Security regularly attends Canary Wharf for specialist door, window, and lock services in commercial premises and managed residential buildings. We're experienced in working within the requirements of corporate and high-security environments."
      introContent={
        <>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Canary Wharf presents unique requirements for door and window services. The area's commercial buildings and managed residential towers have sophisticated systems, strict access procedures, and expectations of professional service that matches their corporate environment.
          </p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            We regularly attend Canary Wharf for scheduled work—not emergency lockouts, but planned repairs and maintenance where our specialist skills add value. From aluminium glazed entrance systems to apartment balcony doors, from multipoint locks to access-controlled internal doors, we understand the systems used in these buildings.
          </p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            Working in managed buildings means coordinating with concierges, property managers, and building management teams. We're experienced in this environment—understanding security sign-in procedures, working considerately in shared spaces, and communicating professionally with all stakeholders.
          </p>
        </>
      }
      servicesEmphasis={[
        {
          title: "Aluminium Commercial Door Systems",
          description: "Canary Wharf's commercial buildings feature high-specification aluminium entrance systems. We repair closers, adjust alignment, replace handles and locks, and maintain these systems to the standard expected in corporate environments."
        },
        {
          title: "Managed Apartment Services",
          description: "The residential towers around Canary Wharf have specific requirements—coordinating with building management, working within access procedures, and understanding the systems used in high-specification apartments."
        },
        {
          title: "Glazed Entrance Repairs",
          description: "Glass-fronted entrances and internal glazed doors require careful handling. We repair mechanisms, replace hardware, and address glazing issues while maintaining the appearance expected in premium buildings."
        },
        {
          title: "Balcony & Terrace Door Systems",
          description: "High-rise apartments have balcony doors subject to wind loading and frequent use. We service locks, adjust alignment, and maintain these doors for secure, smooth operation."
        },
        {
          title: "Access Control Integration",
          description: "Many Canary Wharf doors integrate with access control systems. We work on the mechanical elements—locks, closers, handles—while respecting electronic security systems."
        },
        {
          title: "Scheduled Maintenance",
          description: "For property managers overseeing multiple units or buildings, we provide scheduled maintenance programmes—regular servicing that prevents problems and maintains building standards."
        }
      ]}
      localContextTitle="Working With Building Management in Canary Wharf"
      localContext={
        <>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            <strong>Before booking:</strong> Tell us what building management requires from contractors—induction, permits to work, method statements, or specific working hours. We'll confirm what we can provide upfront so there are no surprises at the security desk.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            <strong>Out-of-hours work:</strong> For offices, retail units, and communal areas, repairs to entrance doors and closers are often best done early morning, in the evening, or at weekends to avoid disrupting occupants. Let us know your preferred window when you get in touch.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            <strong>Commercial door faults:</strong> If an aluminium door drops or fails to latch, an overhead or floor-spring closer slams or won't close, or pivots and handles feel worn, send photos of the closer and the lock edge so we can identify the hardware before attending.
          </p>
        </>
      }
      commonProblems={[
        {
          title: "Commercial door closer failing",
          description: "Heavy-use doors need robust closers. We repair or replace with appropriate commercial-grade units."
        },
        {
          title: "Apartment balcony door misaligned",
          description: "Building movement and use cause alignment issues. We adjust for proper closing and locking."
        },
        {
          title: "Aluminium entrance handle damaged",
          description: "High-traffic damage to entrance hardware. We source and fit matching replacements."
        },
        {
          title: "Internal fire door issues",
          description: "Fire doors must close and latch properly. We adjust and repair to ensure compliance."
        },
        {
          title: "Window mechanism failures in apartments",
          description: "Tilt & turn and casement windows in high-rises have specific issues. We repair mechanisms expertly."
        },
        {
          title: "Multipoint lock problems",
          description: "Apartment entrance doors with multipoint locks need specialist repair when faults develop."
        }
      ]}
      whyChooseUs={
        <>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Our experience attending Canary Wharf means we understand the environment. We arrive appropriately presented, follow security procedures, and conduct ourselves professionally throughout—because the buildings and their occupants expect nothing less.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            We specialise in the systems found in Canary Wharf buildings—commercial-grade aluminium doors, high-specification apartment hardware, and contemporary locking mechanisms. This expertise means accurate diagnosis and effective repairs.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            For property managers and building management companies, we offer reliable partnership. Clear quotations, work completed as specified, proper documentation, and ongoing availability for future requirements. Professional service for professional buildings.
          </p>
        </>
      }
      ctaText="Need Specialist Services in Canary Wharf?"
    />
  );
};
